/**
 * @generated SignedSource<<76fc85713e80ab1d3eb34ee0da1418e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTaskSingleGroupingMode = "SECTION" | "TEAM";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type CreateWidgetTaskSingleInput = {
  grouping?: WidgetTaskSingleGroupingMode | null;
  positionX: number;
  positionY: number;
  sectionIds?: ReadonlyArray<string> | null;
  size: WidgetTaskSingleSize;
  taskId: string;
  teamIds?: ReadonlyArray<string> | null;
  title?: string | null;
};
export type WAKPIMutation$variables = {
  input: CreateWidgetTaskSingleInput;
  storecastId: string;
};
export type WAKPIMutation$data = {
  readonly dashboard: {
    readonly createWidgetTaskSingle: {
      readonly id: string;
    };
  };
};
export type WAKPIMutation = {
  response: WAKPIMutation$data;
  variables: WAKPIMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTaskSingle",
        "kind": "LinkedField",
        "name": "createWidgetTaskSingle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAKPIMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAKPIMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "72718675f394fa47336fc9a0643a12e7",
    "id": null,
    "metadata": {},
    "name": "WAKPIMutation",
    "operationKind": "mutation",
    "text": "mutation WAKPIMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTaskSingleInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTaskSingle(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a76cf61830cbedc0cc38d31ad94ec10e";

export default node;
